// extracted by mini-css-extract-plugin
export default {"container":"KomisApp_container__ZSHx-"};